/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.detail.photos.controllers', [])

.controller('ProgramsDetailPhotosController', ['$scope', 'ResolveViewData', function($scope, ResolveViewData) {

    $scope.programsDetailPhotos = {

      isEmpty: true,

      model: {},

      init: function() {
        if (ResolveViewData.data && ResolveViewData.data.success) {
          this.success.init(ResolveViewData);
        }else{
          this.error.init(ResolveViewData);
        }
      },

      success: {
        init: function(response) {
          console.log('ProgramsDetailPhotosController::success::init', response);
          if (!response.data.payload)  { return; }
          $scope.programsDetailPhotos.model = response.data.payload.images;
          if ($scope.programsDetailPhotos.model.length > 0) {
            $scope.programsDetailPhotos.isEmpty = false;
          }
        }
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.programsDetailPhotos.init();

}]);